import CardBlock from './CardBlock';

export default CardBlock;
